module.exports = __webpack_public_path__ + "static/media/1_graph1.c01de0e7.svg";